import React from 'react';
import classnames from 'classnames'
import { Translate, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { domainActions } from '../../../../store/domainStore'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MultiSelect from '../../../common/multiSelect';
import { isNullOrUndefined } from '../../../../store/storeFunctions';
import ModalInner from '../../../layoutItems/modalInner';
import { unicornAttribute } from '../../../../store/marketingListStore';

const FIN_STATEMENT_ROWS = 'fin-statement-values';

class FinStatementsMultiSelect extends React.Component {
    state = {
        chooseTypes: true,
        originalData: null,
        selectedRows: {
            all: [],
            parent: [],
            allSelected: false
        }
    }

    componentDidMount() {
        this.setState({ originalData: this.props.selection });
        this.props.resetDomainData(FIN_STATEMENT_ROWS);
    }

    componentDidUpdate() {
        if (this.props[FIN_STATEMENT_ROWS].isRequesting === false && !isNullOrUndefined(this.props[FIN_STATEMENT_ROWS].requestResult) &&
            this.state.chooseTypes === true) {
            const selected = this.getSelectedRowsByDomainData();
            this.props.finStatementRowsChanged(selected.rows, selected.parent);
            this.setState({ chooseTypes: false, selectedRows: { all: selected.rows, parent: selected.parent, allSelected: selected.all } });
        } else if (this.props[FIN_STATEMENT_ROWS].isRequesting === false && isNullOrUndefined(this.props[FIN_STATEMENT_ROWS].requestResult) &&
            this.state.chooseTypes === false) {
            this.setState({ chooseTypes: true });
        }
    }

    render() {
        return (
            <React.Fragment>
                <div style={{ display: `${this.state.chooseTypes ? "block" : "none"}` }}>
                    <ModalInner title={this.props.translate("MarketingList.Config.FinStmt.Type")} close={() => this.close(true)} style={{ height: '60vh' }}>
                        <MultiSelect {...this.props}
                            ref={(el) => this.fsTypes = el}
                            ok={this.props.finStatementTypesOk}
                            data={this.props.finStatementTypes}
                            name={this.props.finStatementTypes}
                            onClick={() => this.props.ensureDomainData(this.props.finStatementTypes)}
                            selection={this.props.selection[this.props.typesName]}
                            handleChange={this.props.finStatementTypesChanged}
                            isFinancialModal
                        />
                        <div className='modal-inner-buttons'>
                            <button className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={this.nextClicked}>
                                {this.props[FIN_STATEMENT_ROWS].isRequesting === true
                                    ? <FontAwesomeIcon icon='cog' spin />
                                    : <Translate id="Common.Next" />}
                            </button>
                        </div>
                    </ModalInner>
                </div>
                <div style={{ display: `${this.state.chooseTypes ? "none" : "block"}` }}>
                    <ModalInner title={this.props.translate("MarketingList.Config.FinStmt.Rows")} close={() => this.close(false)} style={{ height: '60vh' }}>
                        <MultiSelect {...this.props}
                            ref={(el) => this.fsRows = el}
                            ok={this.props.finStatementRowsOk}
                            data={this.props.finStatementRows}
                            name={this.props.finStatementRows}
                            onClick={() => this.getFsRows()}
                            selection={this.state.selectedRows}
                            handleChange={this.props.finStatementRowsChanged}
                            forceUpdate={true}
                            isFinancialModal
                        />
                        <div className='modal-inner-buttons'>
                            <button className={classnames('bb-button is-primary gradient-1-gray', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={() => { this.props.resetDomainData(FIN_STATEMENT_ROWS); }}>
                                <Translate id="Common.Back" />
                            </button>
                            <button className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={this.submit}>OK</button>
                        </div>
                    </ModalInner>
                </div>
            </React.Fragment>
        )
    }

    getFsRows = () => {
        if (!isNullOrUndefined(this.props.typesName) && this.props.typesName === "finStatementOrganizationsTypes") {
            let types = this.props.getUpdatedSelection()[this.props.typesName].all.map(f => f.extra.part).join("|");
            this.props.forceDomainDataFiltered(this.props.finStatementRows, { marketAttribute: unicornAttribute(), finStatementTypes: "91", parts: types });
        } else {
            let types = this.props.getUpdatedSelection()[this.props.typesName].all.map(f => f.value).join("|");
            this.props.forceDomainDataFiltered(this.props.finStatementRows, { marketAttribute: unicornAttribute(), finStatementTypes: types });
        }
    }

    nextClicked = () => {
        if (this.fsTypes) {
            this.fsTypes.props.ok();
        }
        this.getFsRows();
    }

    submit = () => {
        if (this.fsRows)
            this.fsRows.props.ok();
    }

    close = (chooseTypes) => {
        // Restore state
        this.props.finStatementTypesChanged(this.state.originalData[this.props.typesName].all, this.state.originalData[this.props.typesName].parent);

        if (!chooseTypes) {
            this.props.finStatementRowsChanged(this.state.originalData[this.props.rowsName].all, this.state.originalData[this.props.rowsName].parent);
            this.props.resetDomainData(FIN_STATEMENT_ROWS);
        }

        this.props.close();
    }

    getSelectedRowsByDomainData = () => {
        if (this.props[FIN_STATEMENT_ROWS].isRequesting === true || isNullOrUndefined(this.props[FIN_STATEMENT_ROWS].requestResult))
            return { rows: [], all: false };

        const selection = this.props.getUpdatedSelection()[this.props.rowsName].all;
        const parent = this.props.getUpdatedSelection()[this.props.rowsName].parent;
        const domainIds = this.props[FIN_STATEMENT_ROWS].requestResult.map(x => x.value)
        let selectedRows = [];
        let parentRows = [];

        selection.forEach((s) => {
            if (domainIds.includes(s.value))
                selectedRows.push(s);
        });

        parent.forEach((p) => {
            if (domainIds.includes(p.value))
                parentRows.push(p);
        })

        return { rows: selectedRows.slice(0), parent: parentRows.slice(0), all: selectedRows.length === domainIds.length }
    }
}

export default withLocalize(connect(
    state => state.domain,
    dispatch => bindActionCreators((domainActions), dispatch)
)(FinStatementsMultiSelect));